import React from 'react'

export const SettingsView = () => {
  return (
    <div className="content">
    <div>Settings and configurations</div>
    </div>
  )
}
